import React from 'react';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { commandRibbonLabel } from 'owa-locstrings/lib/strings/commandRibbon.locstring.json';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { isCapabilityEnabled } from 'owa-capabilities';
import { bleedThroughCapability } from 'owa-capabilities-definitions/lib/bleedThroughCapability';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { APP_RIBBON_SECTION, RIBBON_BLEEDTHROUGH_BOTTOM_PADDING } from './constants';

export interface AppRibbonContainerProps {
    children: React.ReactNode;
}
export const AppRibbonContainer: React.FunctionComponent<{
    children: React.ReactNode;
}> = observer(({ children }: AppRibbonContainerProps) => {
    const { container, containerBleedThrough, defaultMargin, denselessMargin, newTransluscent } =
        useStyles();
    const isBleedThroughEnabled = isCapabilityEnabled(bleedThroughCapability);
    const isRPDenselessEnabled = isGlobalFeatureEnabled('rp-denseless');

    return (
        <div
            aria-label={loc(commandRibbonLabel)}
            className={mergeClasses(
                container,
                isBleedThroughEnabled && containerBleedThrough,
                isRPDenselessEnabled && denselessMargin,
                !isRPDenselessEnabled && isBleedThroughEnabled && defaultMargin,
                isRPDenselessEnabled && isBleedThroughEnabled && newTransluscent
            )}
            data-app-section={APP_RIBBON_SECTION}
            role="region"
            tabIndex={-1}
        >
            {children}
        </div>
    );
}, 'AppRibbonContainer');

const useStyles = makeStyles({
    container: {
        flex: '0 0 auto',
        outlineOffset: '-1px',
        zIndex: 2,
    },
    containerBleedThrough: {
        background: 'var(--whiteTranslucent65)',
        backdropFilter: 'blur(24px)',
        borderRadius: '8px',
        padding: `0 0 ${RIBBON_BLEEDTHROUGH_BOTTOM_PADDING}px`,
    },
    defaultMargin: {
        margin: '0 21px 0 0',
    },
    denselessMargin: {
        margin: '0 8px 0 0',
    },
    newTransluscent: {
        background: 'var(--whiteTranslucent50)',
    },
});
